document.querySelectorAll('[data-accordion]').forEach(accordion => {
	const headers = Array.from(accordion.querySelectorAll('.accordion-header'));

	headers.forEach(header => {
		header.addEventListener('click', () => {
			const item = header.closest('.accordion-item');
			const isOpen = item.classList.contains('is-open');

			// Close all items in this accordion
			accordion.querySelectorAll('.accordion-item.is-open').forEach(openItem => {
				openItem.classList.remove('is-open');
				openItem.querySelector('.accordion-header').setAttribute('aria-expanded', 'false');
			});

			// Open clicked item (if it wasn't already open)
			if (!isOpen) {
				item.classList.add('is-open');
				header.setAttribute('aria-expanded', 'true');

				// Scroll the opened item into view with offset for fixed header
				setTimeout(() => {
					const headerEl = document.getElementById('header');
					const offset = 0;
					const top = item.getBoundingClientRect().top + window.scrollY - offset;
					window.scrollTo({ top, behavior: 'smooth' });
				}, 400);
			}
		});

		// Arrow key navigation between accordion headers
		header.addEventListener('keydown', (e) => {
			const index = headers.indexOf(header);
			let target = null;

			if (e.key === 'ArrowDown') {
				e.preventDefault();
				target = headers[index + 1] || headers[0];
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				target = headers[index - 1] || headers[headers.length - 1];
			} else if (e.key === 'Home') {
				e.preventDefault();
				target = headers[0];
			} else if (e.key === 'End') {
				e.preventDefault();
				target = headers[headers.length - 1];
			}

			if (target) {
				target.focus();
			}
		});
	});
});
